var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 pa-0",attrs:{"id":"content-details"}},[_c('v-col',{staticClass:"col-lg-8 py-0 pl-0",attrs:{"cols":"6"}},[_c('MessageDetails')],1),_c('v-col',{staticClass:"col-lg-4 py-0 pr-0 pl-0",attrs:{"cols":"6"}},[_c('DonationDetails')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }